import { render, staticRenderFns } from "./CoreLabel.vue?vue&type=template&id=edb99e5a"
import script from "./CoreLabel.vue?vue&type=script&lang=js"
export * from "./CoreLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports